var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fullIframe.url),expression:"fullIframe.url"}],staticClass:"flex1 h100 w100",staticStyle:{"position":"fixed","top":"0","bottom":"0","left":"0","right":"0","z-index":"4001"}},[_c('iframe',{staticClass:"flex1 h100 w100",attrs:{"src":_vm.viewUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }